export default function globalFilter(
  allAzubis,
  azubisWithAbteilungen,
  selectedBerufe,
  selectedMaerkte,
  selectedAusbildungsjahre,
  selectedAbteilungen,
  selectedIds,
  filterMyAbteilung,
  myAbteilungen,
) {
  let filteredAzubis = filterBerufe(allAzubis, selectedBerufe)
  filteredAzubis = filterMaerkte(filteredAzubis, selectedMaerkte)
  filteredAzubis = filterAusbildungsjahr(filteredAzubis, selectedAusbildungsjahre)
  const selectedAbteilungsIds = selectedAbteilungen?.map(a => a.value)
  filteredAzubis = filterAbteilungen(filteredAzubis, azubisWithAbteilungen, selectedAbteilungsIds)
  if (filterMyAbteilung) {
    filteredAzubis = doFilterMyAbteilung(filteredAzubis, myAbteilungen)
  }

  if (
    anyFilterIsSet(selectedIds) &&
    !anyFilterIsSet(selectedBerufe) &&
    !anyFilterIsSet(selectedMaerkte) &&
    !anyFilterIsSet(selectedAusbildungsjahre) &&
    !anyFilterIsSet(selectedAbteilungsIds)
  ) {
    return selectedIds
  } else {
    return filteredAzubis
      .map(azubi => azubi.id)
      .concat(selectedIds)
      .filter(onlyUnique)
  }
}

function onlyUnique(value, index, self) {
  return self.indexOf(value) === index
}

function anyFilterIsSet(filter) {
  return filter && filter.length > 0
}

function filterBerufe(azubis, berufe) {
  if (!berufe || berufe.length === 0) {
    return azubis
  }

  return azubis.filter(azubi => berufe.includes(azubi.ausbildungsBerufString))
}

function filterMaerkte(azubis, maerkte) {
  if (!maerkte || maerkte.length === 0) {
    return azubis
  }

  return azubis.filter(azubi => maerkte.includes(azubi.markt))
}

function filterAusbildungsjahr(azubis, ausbildungsjahre) {
  if (!ausbildungsjahre || ausbildungsjahre.length === 0) {
    return azubis
  }

  return azubis.filter(azubi => ausbildungsjahre.includes(azubi.ausbildungsjahr))
}

function doFilterMyAbteilung(azubis, myAbteilungen) {
  if (!myAbteilungen) {
    return azubis
  }
  return azubis.filter(azubi => {
    return myAbteilungen.includes(azubi.currentAbteilungsId)
  })
}

function filterAbteilungen(azubis, azubisWithAbteilungen, selectedAbteilungsIds) {
  if (!selectedAbteilungsIds || selectedAbteilungsIds.length === 0) {
    return azubis
  }

  return azubis.filter(azubi => {
    const azubiWithAbteilungen = azubisWithAbteilungen?.filter(a => a.id === azubi.id)
    if (azubiWithAbteilungen.length === 0) {
      return false
    }
    const abteilungenOfAzubi = azubiWithAbteilungen[0].abteilungen
    return selectedAbteilungsIds.filter(element => abteilungenOfAzubi.includes(element)).length > 0
  })
}
